import React, { createContext, useCallback, useContext, useMemo, useState } from "react"

const MobileDrawerContext = createContext({
  isDrawerOpen: false,
  registerDrawer: () => {},
})

export function MobileDrawerProvider({ children }) {
  const [openIds, setOpenIds] = useState(() => new Set())

  const registerDrawer = useCallback((id, isOpen) => {
    setOpenIds((prev) => {
      const next = new Set(prev)
      if (isOpen) {
        next.add(id)
      } else {
        next.delete(id)
      }
      return next
    })
  }, [])

  const value = useMemo(
    () => ({
      isDrawerOpen: openIds.size > 0,
      registerDrawer,
    }),
    [openIds, registerDrawer]
  )

  return React.createElement(MobileDrawerContext.Provider, { value }, children)
}

export const useMobileDrawerContext = () => useContext(MobileDrawerContext)
